[
  "falling_block",
  "tnt",
  "item",
  "area_effect_cloud",
  "item_frame",
  "leash_knot",
  "painting",
  "arrow",
  "dragon_fireball",
  "fireball",
  "llama_spit",
  "shulker_bullet",
  "small_fireball",
  "snowball",
  "spectral_arrow",
  "egg",
  "ender_pearl",
  "potion",
  "wither_skull",
  "end_crystal",
  "experience_orb",
  "eye_of_ender",
  "firework_rocket",
  "lightning_bolt",
  "experience_bottle",
  "trident",
  "fishing_bobber",
  "evoker_fangs"
]